// src/components/Banner.js
import React from 'react';
import styled from 'styled-components';

const DesktopBanner = styled.div`
  padding: 4% 0px 0px 0px;
  background-color: #000000;
  text-align: center;
  display: flex;
  max-width: 100%;

  img {
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */
  }

  @media (max-width: 500px) {
    display: none;
  }
`;

const MobileBanner = styled.div`
  background-color: #000000;  
  text-align: center;
  display: none;

  img {
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */
  }

  @media (max-width: 500px) {
    display: block;
  }
`;

const Banner = () => (
  <>
    <DesktopBanner>
      <img src="/images/Banner_pc.png" alt="Menu" />
    </DesktopBanner>
    <MobileBanner>
      <img src="/images/Banner_mobile.png" alt="Menu" />
    </MobileBanner>
  </>
);

export default Banner;
